module.exports = __webpack_public_path__ + "img/header-logo.cd943662.png";